var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-open': _vm.isOpen }},[_c('SlideUpDown',{attrs:{"active":_vm.isOpen,"duration":300}},[_vm._t("default")],2),_c('div',{staticClass:"mo:text-center"},[_c('button',{staticClass:"btn-toggle",on:{"click":_vm.toggle}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }